import React from 'react';
import { ReactComponent as PlusIcon } from 'common/icons/plus.svg';

export type PlusButtonProps = {
  className?: string;
  onClick?: () => void;
};

const PlusButton = ({ className, onClick }: PlusButtonProps) => {
  return (
    <button onClick={onClick} className={`planner-plus-button ${className || ''}`}>
      <PlusIcon className='svg-black' />
    </button>
  );
};

export default PlusButton;
